const DATA = {
  title: "Reading Room Warsaw",
  items: [
    {
      title: "Macroeconomic views",
      items: [
        {
          name: "Arnab Das, Global Equities in an America First World",
          link: "/pdf/Invesco_Global Equities in an America-First_World_January_2025_STAMPED.pdf",
        },
        {
          name: "Trump’s Self-Fulfilling Crisis",
          description:
            "Stephen S. Roach of Yale University and former chairman of Morgan Stanley Asia, writes about Trump’s policy frenzy that could create an economic crisis.",
          link: "https://www.project-syndicate.org/commentary/trump-false-claims-of-disastrous-us-economy-could-create-crisis-by-stephen-s-roach-2025-02",
        },
        {
          name: "Can America Maintain External Sustainability?",
          description:
            "Yu Yongding, former president of the China Society of World Economics and director of the Institute of World Economics and Politics at the Chinese Academy of Social Sciences, writes for Project Syndicate on the net foreign-debt-to-GDP ratio and influence of foreign capital into US stock markets.",
          link: "https://www.project-syndicate.org/commentary/america-external-sustainability-at-risk-trump-debt-deficit-by-yu-yongding-2025-02",
        },
        {
          name: "Debt Vulnerabilities And Financing Challenges In Emerging Markets And Developing Economies—An Overview Of Key Data",
          description: "IMF February Policy Report",
          link: "https://www.imf.org/en/Publications/Policy-Papers/Issues/2025/02/19/Debt-Vulnerabilities-And-Financing-Challenges-In-Emerging-Markets-And-Developing-Economies-562218",
        },
        {
          name: "The Post-Pandemic Fiscal Tightrope",
          description:
            "Hoe Ee Khor, Rolf Strauch, and Carlos Giraldo explore how fragmentation, climate change, and population aging is shaping policymakers' reactions to fiscal consolidation with rising expenditure needs.",
          link: "https://www.project-syndicate.org/commentary/asia-latin-america-europe-face-trade-woes-climate-change-population-aging-by-hoe-ee-khor-et-al-2025-02",
        },
        {
          name: "The European Union’s new fiscal framework: a good start, but challenges loom",
          description:
            "Nicolas Boivin and Zsolt Darvas examine the EU’s fiscal plans and how countries have differed in their views on growth and inflation.",
          link: "https://www.bruegel.org/policy-brief/european-unions-new-fiscal-framework-good-start-challenges-loom",
        },
        {
          name: "The economics of the new Monroe Doctrine",
          description:
            "David Lubin reflects on how the US asserting its self-perceived right to unrestrained autonomy in the Western Hemisphere including where and what the Trumpian vision gets wrong.",
          link: "https://www.chathamhouse.org/2025/02/economics-new-monroe-doctrine",
        },
        {
          name: "From open door to spheres of influence: US and the new global order",
          description:
            "Marc Chandler, Chief Market Strategist at Bannockburn Global Forex, writes for OMFIF about Trump’s reshaping of the global order on financial markets so far.",
          link: "https://www.omfif.org/2025/02/from-open-door-to-spheres-of-influence-us-and-the-new-global-order/",
        },
        {
          name: "What’s the future of global trade?",
          description:
            "In this podcast,chief economics commentator at the Financial Times, Martin Wolf, talks to Richard Baldwin, professor of international economics at IMD Business School.",
          link: "https://www.ft.com/content/07acaf4b-19e5-4d96-8ea7-2d7acc7940ce",
        },
        {
          name: "Trade in Transition 2025: Balancing optimism with caution",
          description: "The Economist Impact’ fifth yearly report on trade",
          link: "https://impact.economist.com/projects/trade-in-transition/key-findings/key-finding-2/",
        },
        {
          name: "Is the World Trade Organization still relevant?",
          description:
            "Alan Wm. Wolff of the Peterson Institute for International Economics discusses the shift in US policies and reforms needed to the WTO to keep it relevant.",
          link: "https://www.piie.com/publications/policy-briefs/2024/world-trade-organization-still-relevant",
        },
        {
          name: "The mounting risks to US exceptionalism",
          description:
            "Mohamed El-Erian writes for the Financial Times about how Trump’s policy changes could make companies more cautious on spending and investment.",
          link: "https://www.ft.com/content/1529da3b-24fa-4728-ae1a-180df1782c7a",
        },
        {
          name: "Global defence spending soars to new high",
          description:
            "Fenella McGurty writes for the Institute of International Strategic Studies (IISS) about how much global defence spending has risen over the past decade and the outlook for future spending.",
          link: "https://www.iiss.org/online-analysis/military-balance/2025/02/global-defence-spending-soars-to-new-high/",
        },
        {
          name: "War or Peace in Ukraine: US Moves and European Choices",
          description:
            "Francois Heisburg writes for the IISS about the impact of the war in Ukraine on Russia, Trump’s proposals, and how all of this may affect Europe.",
          link: "https://www.iiss.org/online-analysis/survival-online/2025/02/war-or-peace-in-ukraine-us-moves-and-european-choices/",
        },
      ],
    },
    {
      title: "Stocks and ETFs",
      items: [
        {
          name: "How big is the stock market’s America bubble?",
          description:
            "Gideon Rachman writes for the Financial Times about US stock markets vulnerability to AI and tech stocks valuations.",
          link: "https://www.ft.com/content/80d0ca38-7b15-4432-891d-d9b1d5b080ca",
        },
        {
          name: "Doge could make funds vulnerable to front-running, Democrats warn",
          description:
            "David Isenberg writes for the Financial Times about the risks of Elon Musk having access to SEC data.",
          link: "https://www.ft.com/content/fdba4e2a-cbdd-4fc8-804e-dba9b100f058",
        },
        {
          name: "European stocks outpace Wall Street since Donald Trump took office",
          description:
            "Arjun Neil Alim and Ian Smith write for the Financial Times about the unexpectedly strong performance of European indices to date this year.",
          link: "https://www.ft.com/content/3436a0b9-fbb0-44be-af15-681318415a5d",
        },
        {
          name: "The Decline In U.S. Stocks To Choose From: What It Means For Investors",
          description:
            "Wes Mos writes for Forbes about the impact M&A and fewer IPOs are having on market concentration and investor opportunities.",
          link: "https://www.forbes.com/sites/wesmoss/2025/02/03/the-decline-in-us-stocks-to-choose-from-what-it-means-for-investors/",
        },
      ],
    },
    {
      title: "Commodities",
      items: [
        {
          name: "Europe’s energy information problem",
          description:
            "Ben McWilliams, Simone Tagliapietra, Georg Zachman write for think-tank Bruegel about energy information gaps and reporting obligations.",
          link: "https://www.bruegel.org/policy-brief/europes-energy-information-problem",
        },
        {
          name: "Oil Markets in 2025: Divergence in narrative",
          description:
            "A discussion of the factors that can explain the divergence in the oil market outlook for 2025 and the wide set of uncertainties that dictate the narrative in the year ahead.",
          link: "https://www.oxfordenergy.org/publications/oil-markets-in-2025-divergence-in-narrative/",
        },
        {
          name: "Gold price hits a new high in 2025 – could it soar higher?",
          description:
            "Dan McEvoy writes for <i>Moneyweek</i> about the impact economic and geopolitical uncertainty has and will continue to have on gold prices.",
          link: "https://moneyweek.com/investments/commodities/gold/gold-price",
        },
        {
          name: "Gold finds a new sparkle in tokenisation",
          description:
            "Cici Lu McCalman, Head of Research at Matrixdock, writes for OMFIF about how gold tokenisation will surpass gold ETFs.",
          link: "https://www.omfif.org/2025/02/gold-finds-a-new-sparkle-in-tokenisation/",
        },
      ],
    },
    {
      title: "Cryptocurrencies and digital ecosystem developments",
      items: [
        {
          name: "Bitcoin reserves won’t secure America’s future, only a platform play will",
          description:
            "Christian Catalini, Co-founder of Lightspark and the Massachusetts Institute of Technology Cryptoeconomics Lab, writes for OMFIF on how a well developed infrastructure could allow Bitcoin and Stablecoins to reinforce dollar dominance.",
          link: "https://www.omfif.org/2025/02/bitcoin-reserves-wont-secure-americas-future-only-a-platform-play-will/",
        },
        {
          name: "Securing The Future Of Digital Assets: How To Prevent The Trillion-Dollar Heist",
          description:
            "Sebastian Williams writing for Forbes on how to keep digital currencies secure.",
          link: "https://www.forbes.com/sites/digital-assets/2025/02/25/securing-the-future-of-digital-assets-how-to-prevent-the-trillion-dollar-heist/",
        },
        {
          name: "Encryption ‘back doors’ are a bad idea",
          description:
            "A view from the Financial Times Editorial Board on governments demanding access to digital service providers information.",
          link: "https://www.ft.com/content/186a9bb6-9e62-47ce-b974-ce52a2d73e9f",
        },
      ],
    },
  ],
}

export default DATA
